import { incoterms } from "../../shared/incoterms/incoterms.const";

export const quoteDirection = {
  IMP: "import",
  EXP: "export",
  XTR: "crosstrade",
};

// The trade direction an incoterm implies: the seller's own terms are an import,
// the terms that carry the cargo onward for the buyer are an export.
export const incotermQuoteDirection: Record<string, string> = {
  [incoterms.exw]: quoteDirection.IMP,
  [incoterms.fca]: quoteDirection.IMP,
  [incoterms.fas]: quoteDirection.IMP,
  [incoterms.fob]: quoteDirection.IMP,
  [incoterms.cfr]: quoteDirection.EXP,
  [incoterms.cif]: quoteDirection.EXP,
  [incoterms.cpt]: quoteDirection.EXP,
  [incoterms.cip]: quoteDirection.EXP,
  [incoterms.dpu]: quoteDirection.EXP,
  [incoterms.dap]: quoteDirection.EXP,
  [incoterms.ddp]: quoteDirection.EXP,
};

// Undefined when the incoterm names no direction, in which case the quote keeps the one it has.
export function directionForIncoterm(incotermType: string): string | undefined {
  return incotermQuoteDirection[incotermType];
}
